var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fit-warper"},[_c('div',{staticClass:"title pf-medium"},[_vm._v("适用人群")]),_c('h3',[_vm._v(_vm._s(_vm.applyPeople))]),_c('p',[_vm._v(_vm._s(_vm.applicability))])])}
var staticRenderFns = []

export { render, staticRenderFns }